module.exports = __webpack_public_path__ + "32ace604abd2387ab2d6b703eaad3425.MP3";